<template lang="pug">
  .details-wrapper
    .name
      DBLabel(title="nome:", :body="group.name")
    .companies
      PMultiSelect(
        v-model="companies"
        useCommon="companies"
        labelItem="name"
        :title="$wp('company')"
        :displayMode="true"
      )
    .groups
      PMultiSelect(
        v-model="groups"
        useCommon="userGroups"
        labelItem="name"
        :title="$wp('group')"
        :displayMode="true"
      )

    .actions-buttons
      PButton(color="info", size="md", @click="editGroup" title="editar")
        .icon-ptt-icons-lapis

      PConfirmButton(text="Excluir este grupo?" color="danger", size="md", @click="removeGroup", :loading="removeLoading" title="excluir")
        .icon-ptt-icons-excluir

</template>

<script>
import DBLabel from 'src/common/SmartTable/DBLabel'

export default {
  name: 'Details',
  components: {DBLabel},
  props: {
    group: {type: Object, required: true}
  },
  data () {
    return {
      companiesData: { selected: [] },
      groupData: { selected: [] },
      removeLoading: false
    }
  },
  computed: {
    companies: {
      set (val) { this.companiesData = val },
      get () {
        return {
          selected: this.group.companies
        }
      }
    },
    groups: {
      set (val) { this.groupData = val },
      get () {
        return {
          selected: this.group.groups
        }
      }
    }
  },
  methods: {
    async removeGroup () {
      this.removeLoading = true
      try {
        const result = await this.$API.userGroup.remove({ id: this.group.id })
        console.log(result)
      } catch (e) {
        const msg = e.data.error || 'Aconteceu um erro. Tente novamente.'
        this.$swal({
          type: 'error',
          title: 'Atenção',
          text: msg
        })
      }
      this.removeLoading = false
      this.$emit('reloadTable')
    },
    editGroup () {
      // this.$router.push(`/user-group/${this.group.id}`)
      this.$emit('editGroup', this.group.id)
    }
  }
}
</script>

<style scoped lang="scss">
.details-wrapper {
  height: 100%;

  display: grid;

  .name {
    margin-bottom: 20px;
  }

  .name, .companies, .groups, .actions-buttons {
    grid-column: 1/3;
  }

  .actions-buttons {
    margin-top: 20px;
    justify-self: right;
    align-self: end;

    display: grid;
    grid-gap: 2px;
    grid-auto-flow: column;
  }
}
</style>
